export default __webpack_public_path__ + "static/media/develop-team.74952354.png";